<template>
  <HeaderDialog
    v-if="showHideDialog"
    id="add_users_calendars"
    :color="primaryColor"
    :title="$t('common.addCalendar')"
    :show="showHideDialog"
    :persistent="false"
    :loading="loading"
    width="700"
    @close="showHideDialog = false"
    @action="InsertUsersCalendars"
    :disabledAction="invalid"
    :closeText="$t('action.cancel')"
    button-class="text-none text-subtitle-1 font-weight-medium elevation-0"
  >
    <template v-slot:body>
      <div>
        <v-card-text>
          {{ $t("common.selectCalendars") }}
        </v-card-text>
        <v-card-text v-html="$t('common.addCalendarDescription')" />
        <v-card-text class="d-flex align-baseline pt-0 flex-wrap">
          {{ $t("common.addCalendarsHelpText") }}:
          <v-btn
            text
            :color="secondaryColor"
            class="d-inline px-1 mx-1 text-none ml-3"
            :disabled="loading"
            :loading="loading"
            @click="getCalendars"
            outlined
          >
            {{ $t("common.searchCalendars") }}
          </v-btn>
        </v-card-text>
        <v-autocomplete
          v-model="calendars"
          :items="allCalendars"
          multiple
          outlined
          item-text="summary"
          item-value="id"
          hide-details
          clearable
          :disabled="loading || disabled"
          :loading="loading"
          class="px-4"
        >
          <template v-slot:selection="{ attrs, item, parent, selected }">
            <v-chip
              v-bind="attrs"
              color="lighten-3"
              :input-value="selected"
              pill
              class="ma-1 link"
              placeholder="Nenhuma agenda selecionada"
            >
              <span class="pr-2">
                {{ item.summary }}
              </span>
              <v-icon small @click="parent.selectItem(item)"> $delete </v-icon>
            </v-chip>
          </template>

          <template v-slot:item="{ item, on, attrs }">
            <v-list-item
              v-on="on"
              v-bind="attrs"
              :active-class="lightColors[productName]"
              :class="`mb-1`"
              style="width: inherit"
            >
              <v-list-item-icon>
                <v-icon
                  :color="isSelected(item.id) ? `${primaryColor} darken-2` : ''"
                  v-text="
                    isSelected(item.id)
                      ? 'ph-fill ph-check-square'
                      : 'ph-square'
                  "
                />
              </v-list-item-icon>
              <v-list-item-content style="max-width: 500px">
                <v-list-item-title
                  class="text-left font-weight-medium"
                  style="max-width: 500px"
                  >{{ item.summary }}
                </v-list-item-title>
                <v-list-item-subtitle
                  class="text-left"
                  style="max-width: 500px"
                >
                  <div style="max-width: 500px; white-space: normal">
                    {{ item.description }}
                  </div>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
        <p
          v-if="usersHasNotGmailActive && !showScopesOverlay"
          class="red--text mt-3 mb-1 mx-4"
        >
          * {{ `${$t("common.multipleInactiveEmailService")}` }}
        </p>
        <!-- OVERLAY FOR SCOPES MISSING  -->
        <OverlayScopes
          :overlay="showScopesOverlay"
          :functionality="$t('common.insertUserIntoCalendar')"
          dense
          :loading="loadingScopes"
        />
      </div>
    </template>
  </HeaderDialog>
</template>
<script>
import OverlayScopes from "@/components/general/OverlayScopes.vue";
import { lightColors } from "@/helpers/variables/colors";
import { mapActions, mapGetters } from "vuex";

import {
  INCREMENTAL_SCOPES,
  MARKETPLACE_APP_URL,
} from "@/helpers/variables/scopes";

export default {
  name: "InsertUsersCalendars",

  components: {
    OverlayScopes,
  },

  props: {
    show: { type: Boolean, required: true },
    users: { type: Array, required: true },
  },

  data() {
    return {
      calendars: null,
      lightColors,
      loadingScopes: false,
      showScopesOverlay: false,
      disabled: false,
      MARKETPLACE_APP_URL,
    };
  },

  computed: {
    ...mapGetters([
      "calendarsLoading",
      "allCalendars",
      "secondaryColor",
      "primaryColor",
      "productName",
      "isAdmin",
      "scopeCode",
    ]),

    loading() {
      return this.loadingScopes || this.calendarsLoading;
    },

    invalid() {
      return this.loading || this.disabled || !this.calendars?.length;
    },

    usersHasNotGmailActive() {
      return this.users.some((user) => !user.is_gmail_enabled);
    },

    showHideDialog: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("close");
      },
    },
  },

  watch: {
    show() {
      if (this.show) {
        this.calendars = null;
      }
    },
  },

  methods: {
    ...mapActions(["checkScopes", "getCalendars", "insertCalendars"]),

    isSelected(id) {
      return (this.calendars || []).find((item) => item === id);
    },

    async InsertUsersCalendars() {
      const payload = {
        users: this.users.map((item) => item.email),
        calendars: this.calendars,
      };
      await this.insertCalendars(payload)
        .then(() => this.$emit("getUserCalendars"))
        .finally(() => {
          this.$emit("close");
          this.$emit("saveLog");
        });
    },
  },
  async beforeMount() {
    const calendarScope = INCREMENTAL_SCOPES.CALENDAR;
    if (!this.scopeCode(calendarScope)) {
      this.loadingScopes = true;
      const payload = {
        scopes: [calendarScope],
      };

      await this.checkScopes(payload)
        .then(() => {
          this.disabled = false;
          if (this.allCalendars.length == 0) {
            this.getCalendars();
          }
        })
        .catch(() => {
          this.disabled = true;
          if (this.scopeCode(calendarScope) === "INVALID_GOOGLE_ACCESS_TOKEN") {
            this.$emit("setScopesMissingOverlay", true);
            this.showScopesOverlay = true;
          }
        })
        .finally(() => {
          this.loadingScopes = false;
        });
      return;
    } else if (
      this.scopeCode(calendarScope) === "INVALID_GOOGLE_ACCESS_TOKEN"
    ) {
      this.showScopesOverlay = true;
    }
  },
};
</script>
